import { Group, GroupProps } from '@mantine/core'

export type TRowProps = GroupProps

export const Row: React.FC<TRowProps> = ({ children, ...groupProps }) => (
  <Group align="center" {...groupProps}>
    {children}
  </Group>
)
